import React, { useEffect, useState } from 'react';

export const SearchBoxGlobal = props => {
  const { controller, controllerSearch } = props;
  const { labels } = props;
  const searchURI = props.resultsPage;
  const searchPage = window.location.toString().split('#')[0] === searchURI;
  const [state, setState] = useState(controller.state);
  const [searchValue, setSearchValue] = useState('');
  const [dataValue, setDataValue] = useState('');
  const minQueryLengthForSuggestions = 3;

  useEffect(() => {
    if (!searchPage) {
      controller.subscribe(() => setState(controller.state));
    }
  }, [controller]);

  useEffect(() => {
    if (searchPage) {
      controllerSearch.subscribe(() => setState(controllerSearch.state));
    }
  }, [controllerSearch]);

  useEffect(() => {
    if (state.value === dataValue) {
      setSearchValue(dataValue);
      setDataValue(null);
    }
  }, [state]);

  useEffect(() => {
    window.addEventListener('clearSearchCoveo', handleClear);

    const data = localStorage.getItem('coveo_standalone_search_box_data');
    if (data) {
      setDataValue(JSON.parse(data).value);
    } else {
      setDataValue(null);
    }
    return () => {
      window.removeEventListener('clearSearchCoveo', handleClear);
    };
  }, []);

  const suggestionStyle = {
    cursor: 'pointer'
  };

  const handleSuggestionClick = (e, suggestion) => {
    e.preventDefault();
    if (searchPage) {
      controllerSearch.selectSuggestion(suggestion);
    } else {
      controller.selectSuggestion(suggestion);
    }
  };
  const handleSubmit = e => {
    e?.preventDefault();
    if (searchPage) {
      controllerSearch.submit();
    } else {
      controller.submit();
    }
  };

  const handleClear = () => {
    controllerSearch.clear();
  };

  if (state.redirectTo) {
    const { redirectTo, value, analytics } = state;
    const data = JSON.stringify({ value, analytics });
    localStorage.setItem('coveo_standalone_search_box_data', data);
    window.location.href = redirectTo;
  }

  if (state.isLoading && dataValue === null) {
    if (searchValue !== state.value) {
      setSearchValue(state.value);
    }
  }

  useEffect(() => {
    window.addEventListener('submitSearchCoveo', handleSubmit);

    return () => {
      window.removeEventListener('submitSearchCoveo', handleSubmit);
    };
  }, []);

  return (
    <div
      className={`coveo-search-results__search-box coveo-search-results__search-box${
        props.modifier || ''
      } form-input header-search__term form-input--filled form-input--button`}
      onKeyDown={e => {
        if (
          e.key === 'ArrowDown' &&
          state.suggestions.length > 0 &&
          state.value?.length > minQueryLengthForSuggestions
        ) {
          e.preventDefault();
          const focusedElement = document.querySelector(
            '.coveo-search-results--header .coveo-search-results__search-box-suggestion:focus'
          );
          const firstSuggestion = document.querySelector(
            '.coveo-search-results--header .coveo-search-results__search-box-suggestion:first-child'
          );
          const lastSuggestion = document.querySelector(
            '.coveo-search-results--header .coveo-search-results__search-box-suggestion:last-child'
          );

          if (focusedElement === null) {
            firstSuggestion.focus();
          } else if (focusedElement === lastSuggestion) {
            // firstSuggestion.focus();
            document
              .getElementById('coveo-search-results-search-box-header')
              .focus();
          } else {
            focusedElement.nextSibling.focus();
          }
        }

        if (
          e.key === 'ArrowUp' &&
          state.suggestions.length > 0 &&
          state.value.length > minQueryLengthForSuggestions
        ) {
          e.preventDefault();
          const focusedElement = document.querySelector(
            '.coveo-search-results--header .coveo-search-results__search-box-suggestion:focus'
          );
          const firstSuggestion = document.querySelector(
            '.coveo-search-results--header .coveo-search-results__search-box-suggestion:first-child'
          );
          const lastSuggestion = document.querySelector(
            '.coveo-search-results--header .coveo-search-results__search-box-suggestion:last-child'
          );

          if (focusedElement === null) {
            lastSuggestion.focus();
          } else if (focusedElement === firstSuggestion) {
            // lastSuggestion.focus();
            document
              .getElementById('coveo-search-results-search-box-header')
              .focus();
          } else {
            focusedElement.previousSibling.focus();
          }
        }
      }}
    >
      <input
        autoComplete="off"
        aria-label="Search Box"
        className="coveo-search-results__search-box-input form-input__field"
        name="coveo-search-results-search-box"
        id="coveo-search-results-search-box-header"
        value={searchValue}
        onChange={e => {
          searchPage
            ? controllerSearch.updateText(e.target.value)
            : controller.updateText(e.target.value);
          setSearchValue(e.target.value);
        }}
        onFocus={() => setSearchValue(state.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            handleSubmit(e);
          }
        }}
        placeholder={labels.searchPlaceholder}
      />
      <label
        className="coveo-search-results__search-box-label"
        htmlFor="coveo-search-results-search-box-header"
      >
        {labels.search}
      </label>
      <button
        disabled={searchValue?.length ? '' : 'disabled'}
        aria-label="Clear Search"
        onClick={() => {
          setSearchValue('');
          searchPage ? controllerSearch.clear() : controller.clear();
        }}
        className={`coveo-search-results__search-box-clear ${
          searchValue ? 'coveo-search-results__search-box-clear--active' : ''
        } form-input__icon-wrapper form-input__clear-btn`}
        type="button"
      >
        <svg
          viewBox="0 0 120 120"
          className="form-input__icon form-input__icon-close"
          width="24"
          height="24"
          role="presentation"
        >
          <use xlinkHref="#close-regular"></use>
        </svg>
      </button>
      {state.suggestions.length > 0 &&
        state.value.length > minQueryLengthForSuggestions && (
        <div className="coveo-search-results__search-box-suggestion-list">
          {state.suggestions.map(suggestion => (
            <button
              className="coveo-search-results__search-box-suggestion"
              style={suggestionStyle}
              key={suggestion.rawValue}
              onClick={e => handleSuggestionClick(e, suggestion.rawValue)}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  handleSuggestionClick(e, suggestion.rawValue);
                }
              }}
              dangerouslySetInnerHTML={{
                __html: suggestion.highlightedValue
              }}
              onMouseDown={e => e.preventDefault()}
            ></button>
          ))}
        </div>
      )}
      <button
        aria-label="Search"
        disabled={searchValue?.length ? '' : 'disabled'}
        onClick={() => {
          if (searchValue?.length > 0) {
            handleSubmit();
          }
        }}
        className={`coveo-search-results__search-box-search ${
          state.value ? 'coveo-search-results__search-box-search--active' : ''
        } btn siplast--sg header-search__term-btn`}
      >
        <svg
          viewBox="0 0 20 20"
          className="form-input__icon form-input__icon-search"
          width="22"
          height="22"
          role="presentation"
        >
          <use xlinkHref="#search" />
        </svg>
      </button>
    </div>
  );
};
